import { Link } from 'react-router-dom';

import { UserAvatar } from '@app/shared/ui/atoms/Common';
import { HeaderBalanceLink } from '@app/shared/ui/molecules/Layout';
import { useGetCurrentUserProfileQuery } from '@app/store/slices/users/usersApi';
import { useBalance } from '@app/shared/hooks/useBalance';
import { defaultTelegramVibrate } from '@app/shared/utils/common';
import { HEADER_COOKIE_BALANCE_ID } from '@app/shared/constants/layout';
import { Page } from '@app/routes';
import { PriceType } from '@app/shared/types/common';
import { navbarDOMLogoBlack } from '@app/assets';

export function Header() {
  const { data: user, isLoading: isUserLoading } = useGetCurrentUserProfileQuery();
  const { balance, isFetching } = useBalance();

  return (
    <header className="flex items-center justify-between p-[8px_20px_8px] z-10 gap-1">
      <Link to={Page.HOME} onClick={defaultTelegramVibrate}>
        <img src={navbarDOMLogoBlack} alt="DOM Logo" className="h-[34px] w-[87px] object-contain" />
      </Link>

      <div className="flex items-center gap-1 xs:gap-2.5">
        <HeaderBalanceLink
          type={PriceType.COOKIE}
          balance={balance?.cookieBalance}
          isLoading={isFetching}
          id={HEADER_COOKIE_BALANCE_ID}
          onClick={defaultTelegramVibrate}
        />
        <HeaderBalanceLink
          type={PriceType.TON}
          balance={balance?.tonBalance}
          isLoading={isFetching}
          onClick={defaultTelegramVibrate}
        />
        <Link to={Page.PROFILE} onClick={defaultTelegramVibrate}>
          <UserAvatar
            avatar={user?.avatar}
            isAvatarLoading={isUserLoading}
            gender={user?.gender}
            className="size-8"
          />
        </Link>
      </div>
    </header>
  );
}
